[
  [
    {
      "id": "acid-splash",
      "title": "Acid Splash",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:acid-splash"
    },
    {
      "id": "blade-ward",
      "title": "Blade Ward",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:blade-ward"
    },
    {
      "id": "booming-blade",
      "title": "Booming Blade",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:booming-blade"
    },
    {
      "id": "chill-touch",
      "title": "Chill Touch",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:chill-touch"
    },
    {
      "id": "control-flames",
      "title": "Control Flames",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:control-flames"
    },
    {
      "id": "create-bonfire",
      "title": "Create Bonfire",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:create-bonfire"
    },
    {
      "id": "dancing-lights",
      "title": "Dancing Lights",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:dancing-lights"
    },
    {
      "id": "encode-thoughts",
      "title": "Encode Thoughts",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:encode-thoughts"
    },
    {
      "id": "fire-bolt",
      "title": "Fire Bolt",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:fire-bolt"
    },
    {
      "id": "friends",
      "title": "Friends",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:friends"
    },
    {
      "id": "frostbite",
      "title": "Frostbite",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:frostbite"
    },
    {
      "id": "green-flame-blade",
      "title": "Green-Flame Blade",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:green-flame-blade"
    },
    {
      "id": "gust",
      "title": "Gust",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:gust"
    },
    {
      "id": "infestation",
      "title": "Infestation",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:infestation"
    },
    {
      "id": "light",
      "title": "Light",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:light"
    },
    {
      "id": "lightning-lure",
      "title": "Lightning Lure",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:lightning-lure"
    },
    {
      "id": "mage-hand",
      "title": "Mage Hand",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:mage-hand"
    },
    {
      "id": "mending",
      "title": "Mending",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:mending"
    },
    {
      "id": "message",
      "title": "Message",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:message"
    },
    {
      "id": "mind-sliver",
      "title": "Mind Sliver",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:mind-sliver"
    },
    {
      "id": "minor-illusion",
      "title": "Minor Illusion",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:minor-illusion"
    },
    {
      "id": "mold-earth",
      "title": "Mold Earth",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:mold-earth"
    },
    {
      "id": "on-off",
      "title": "On/Off (UA)",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:on-off"
    },
    {
      "id": "poison-spray",
      "title": "Poison Spray",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:poison-spray"
    },
    {
      "id": "prestidigitation",
      "title": "Prestidigitation",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:prestidigitation"
    },
    {
      "id": "ray-of-frost",
      "title": "Ray of Frost",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:ray-of-frost"
    },
    {
      "id": "sapping-sting",
      "title": "Sapping Sting",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:sapping-sting"
    },
    {
      "id": "shape-water",
      "title": "Shape Water",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:shape-water"
    },
    {
      "id": "shocking-grasp",
      "title": "Shocking Grasp",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:shocking-grasp"
    },
    {
      "id": "sword-burst",
      "title": "Sword Burst",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:sword-burst"
    },
    {
      "id": "thunderclap",
      "title": "Thunderclap",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:thunderclap"
    },
    {
      "id": "toll-the-dead",
      "title": "Toll the Dead",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:toll-the-dead"
    },
    {
      "id": "true-strike",
      "title": "True Strike",
      "level": 0,
      "url": "http://dnd5e.wikidot.com/spell:true-strike"
    }
  ],
  [
    {
      "id": "absorb-elements",
      "title": "Absorb Elements",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:absorb-elements"
    },
    {
      "id": "acid-stream",
      "title": "Acid Stream (UA)",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:acid-stream"
    },
    {
      "id": "alarm",
      "title": "Alarm",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:alarm"
    },
    {
      "id": "burning-hands",
      "title": "Burning Hands",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:burning-hands"
    },
    {
      "id": "catapult",
      "title": "Catapult",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:catapult"
    },
    {
      "id": "cause-fear",
      "title": "Cause Fear",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:cause-fear"
    },
    {
      "id": "charm-person",
      "title": "Charm Person",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:charm-person"
    },
    {
      "id": "chromatic-orb",
      "title": "Chromatic Orb",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:chromatic-orb"
    },
    {
      "id": "color-spray",
      "title": "Color Spray",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:color-spray"
    },
    {
      "id": "comprehend-languages",
      "title": "Comprehend Languages",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:comprehend-languages"
    },
    {
      "id": "detect-magic",
      "title": "Detect Magic",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:detect-magic"
    },
    {
      "id": "disguise-self",
      "title": "Disguise Self",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:disguise-self"
    },
    {
      "id": "distort-value",
      "title": "Distort Value",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:distort-value"
    },
    {
      "id": "earth-tremor",
      "title": "Earth Tremor",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:earth-tremor"
    },
    {
      "id": "expeditious-retreat",
      "title": "Expeditious Retreat",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:expeditious-retreat"
    },
    {
      "id": "false-life",
      "title": "False Life",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:false-life"
    },
    {
      "id": "feather-fall",
      "title": "Feather Fall",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:feather-fall"
    },
    {
      "id": "find-familiar",
      "title": "Find Familiar",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:find-familiar"
    },
    {
      "id": "fog-cloud",
      "title": "Fog Cloud",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:fog-cloud"
    },
    {
      "id": "frost-fingers",
      "title": "Frost Fingers",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:frost-fingers"
    },
    {
      "id": "gift-of-alacrity",
      "title": "Gift of Alacrity",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:gift-of-alacrity"
    },
    {
      "id": "grease",
      "title": "Grease",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:grease"
    },
    {
      "id": "guiding-hand-ua",
      "title": "Guiding Hand (UA)",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:guiding-hand-ua"
    },
    {
      "id": "healing-elixir-ua",
      "title": "Healing Elixir (UA)",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:healing-elixir-ua"
    },
    {
      "id": "ice-knife",
      "title": "Ice Knife",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:ice-knife"
    },
    {
      "id": "id-insinuation",
      "title": "Id Insinuation (UA)",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:id-insinuation"
    },
    {
      "id": "identify",
      "title": "Identify",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:identify"
    },
    {
      "id": "illusory-script",
      "title": "Illusory Script",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:illusory-script"
    },
    {
      "id": "infallible-relay",
      "title": "Infallible Relay (UA)",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:infallible-relay"
    },
    {
      "id": "jims-magic-missile",
      "title": "Jim's Magic Missile",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:jims-magic-missile"
    },
    {
      "id": "jump",
      "title": "Jump",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:jump"
    },
    {
      "id": "longstrider",
      "title": "Longstrider",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:longstrider"
    },
    {
      "id": "mage-armor",
      "title": "Mage Armor",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:mage-armor"
    },
    {
      "id": "magic-missile",
      "title": "Magic Missile",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:magic-missile"
    },
    {
      "id": "magnify-gravity",
      "title": "Magnify Gravity",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:magnify-gravity"
    },
    {
      "id": "protection-from-evil-and-good",
      "title": "Protection from Evil and Good",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:protection-from-evil-and-good"
    },
    {
      "id": "puppet",
      "title": "Puppet (UA)",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:puppet"
    },
    {
      "id": "ray-of-sickness",
      "title": "Ray of Sickness",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:ray-of-sickness"
    },
    {
      "id": "remote-access",
      "title": "Remote Access (UA)",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:remote-access"
    },
    {
      "id": "sense-emotion",
      "title": "Sense Emotion (UA)",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:sense-emotion"
    },
    {
      "id": "shield",
      "title": "Shield",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:shield"
    },
    {
      "id": "silent-image",
      "title": "Silent Image",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:silent-image"
    },
    {
      "id": "silvery-barbs",
      "title": "Silvery Barbs",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:silvery-barbs"
    },
    {
      "id": "sleep",
      "title": "Sleep",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:sleep"
    },
    {
      "id": "snare",
      "title": "Snare",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:snare"
    },
    {
      "id": "sudden-awakening",
      "title": "Sudden Awakening (UA)",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:sudden-awakening"
    },
    {
      "id": "tashas-caustic-brew",
      "title": "Tasha's Caustic Brew",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:tashas-caustic-brew"
    },
    {
      "id": "tashas-hideous-laughter",
      "title": "Tasha's Hideous Laughter",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:tashas-hideous-laughter"
    },
    {
      "id": "tensers-floating-disk",
      "title": "Tenser's Floating Disk",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:tensers-floating-disk"
    },
    {
      "id": "thunderwave",
      "title": "Thunderwave",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:thunderwave"
    },
    {
      "id": "unseen-servant",
      "title": "Unseen Servant",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:unseen-servant"
    },
    {
      "id": "witch-bolt",
      "title": "Witch Bolt",
      "level": 1,
      "url": "http://dnd5e.wikidot.com/spell:witch-bolt"
    }
  ],
  [
    {
      "id": "aganazzars-scorcher",
      "title": "Aganazzar's Scorcher",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:aganazzars-scorcher"
    },
    {
      "id": "air-bubble",
      "title": "Air Bubble",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:air-bubble"
    },
    {
      "id": "alter-self",
      "title": "Alter Self",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:alter-self"
    },
    {
      "id": "arcane-hacking",
      "title": "Arcane Hacking (UA)",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:arcane-hacking"
    },
    {
      "id": "arcane-lock",
      "title": "Arcane Lock",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:arcane-lock"
    },
    {
      "id": "augury",
      "title": "Augury",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:augury"
    },
    {
      "id": "blindness-deafness",
      "title": "Blindness/Deafness",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:blindness-deafness"
    },
    {
      "id": "blur",
      "title": "Blur",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:blur"
    },
    {
      "id": "borrowed-knowledge",
      "title": "Borrowed Knowledge",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:borrowed-knowledge"
    },
    {
      "id": "cloud-of-daggers",
      "title": "Cloud of Daggers",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:cloud-of-daggers"
    },
    {
      "id": "continual-flame",
      "title": "Continual Flame",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:continual-flame"
    },
    {
      "id": "crown-of-madness",
      "title": "Crown of Madness",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:crown-of-madness"
    },
    {
      "id": "darkness",
      "title": "Darkness",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:darkness"
    },
    {
      "id": "darkvision",
      "title": "Darkvision",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:darkvision"
    },
    {
      "id": "detect-thoughts",
      "title": "Detect Thoughts",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:detect-thoughts"
    },
    {
      "id": "digital-phantom",
      "title": "Digital Phantom (UA)",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:digital-phantom"
    },
    {
      "id": "dragons-breath",
      "title": "Dragon's Breath",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:dragons-breath"
    },
    {
      "id": "dust-devil",
      "title": "Dust Devil",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:dust-devil"
    },
    {
      "id": "earthbind",
      "title": "Earthbind",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:earthbind"
    },
    {
      "id": "enhance-ability",
      "title": "Enhance Ability",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:enhance-ability"
    },
    {
      "id": "enlarge-reduce",
      "title": "Enlarge/Reduce",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:enlarge-reduce"
    },
    {
      "id": "find-vehicle",
      "title": "Find Vehicle (UA)",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:find-vehicle"
    },
    {
      "id": "flaming-sphere",
      "title": "Flaming Sphere",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:flaming-sphere"
    },
    {
      "id": "flock-of-familiars",
      "title": "Flock of Familiars",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:flock-of-familiars"
    },
    {
      "id": "fortunes-favor",
      "title": "Fortune's Favor",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:fortunes-favor"
    },
    {
      "id": "gentle-repose",
      "title": "Gentle Repose",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:gentle-repose"
    },
    {
      "id": "gift-of-gab",
      "title": "Gift of Gab",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:gift-of-gab"
    },
    {
      "id": "gust-of-wind",
      "title": "Gust of Wind",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:gust-of-wind"
    },
    {
      "id": "hold-person",
      "title": "Hold Person",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:hold-person"
    },
    {
      "id": "icingdeath-s-frost",
      "title": "Icingdeath's Frost (UA)",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:icingdeath-s-frost"
    },
    {
      "id": "immovable-object",
      "title": "Immovable Object",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:immovable-object"
    },
    {
      "id": "invisibility",
      "title": "Invisibility",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:invisibility"
    },
    {
      "id": "jims-glowing-coin",
      "title": "Jim's Glowing Coin",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:jims-glowing-coin"
    },
    {
      "id": "kinetic-jaunt",
      "title": "Kinetic Jaunt",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:kinetic-jaunt"
    },
    {
      "id": "knock",
      "title": "Knock",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:knock"
    },
    {
      "id": "levitate",
      "title": "Levitate",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:levitate"
    },
    {
      "id": "locate-object",
      "title": "Locate Object",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:locate-object"
    },
    {
      "id": "magic-mouth",
      "title": "Magic Mouth",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:magic-mouth"
    },
    {
      "id": "magic-weapon",
      "title": "Magic Weapon",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:magic-weapon"
    },
    {
      "id": "maximillians-earthen-grasp",
      "title": "Maximillian's Earthen Grasp",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:maximillians-earthen-grasp"
    },
    {
      "id": "melfs-acid-arrow",
      "title": "Melf's Acid Arrow",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:melfs-acid-arrow"
    },
    {
      "id": "mental-barrier",
      "title": "Mental Barrier (UA)",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:mental-barrier"
    },
    {
      "id": "mind-spike",
      "title": "Mind Spike",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:mind-spike"
    },
    {
      "id": "mind-thrust",
      "title": "Mind Thrust (UA)",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:mind-thrust"
    },
    {
      "id": "mirror-image",
      "title": "Mirror Image",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:mirror-image"
    },
    {
      "id": "misty-step",
      "title": "Misty Step",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:misty-step"
    },
    {
      "id": "nathairs-mischief",
      "title": "Nathair's Mischief",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:nathairs-mischief"
    },
    {
      "id": "nathairs-mischief-ua",
      "title": "Nathair's Mischief (UA)",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:nathairs-mischief-ua"
    },
    {
      "id": "nystuls-magic-aura",
      "title": "Nystul's Magic Aura",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:nystuls-magic-aura"
    },
    {
      "id": "phantasmal-force",
      "title": "Phantasmal Force",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:phantasmal-force"
    },
    {
      "id": "pyrotechnics",
      "title": "Pyrotechnics",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:pyrotechnics"
    },
    {
      "id": "ray-of-enfeeblement",
      "title": "Ray of Enfeeblement",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:ray-of-enfeeblement"
    },
    {
      "id": "rimes-binding-ice",
      "title": "Rime's Binding Ice",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:rimes-binding-ice"
    },
    {
      "id": "rope-trick",
      "title": "Rope Trick",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:rope-trick"
    },
    {
      "id": "scorching-ray",
      "title": "Scorching Ray",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:scorching-ray"
    },
    {
      "id": "see-invisibility",
      "title": "See Invisibility",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:see-invisibility"
    },
    {
      "id": "shadow-blade",
      "title": "Shadow Blade",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:shadow-blade"
    },
    {
      "id": "shatter",
      "title": "Shatter",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:shatter"
    },
    {
      "id": "skywrite",
      "title": "Skywrite",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:skywrite"
    },
    {
      "id": "snillocs-snowball-storm",
      "title": "Snilloc's Snowball Storm",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:snillocs-snowball-storm"
    },
    {
      "id": "spider-climb",
      "title": "Spider Climb",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:spider-climb"
    },
    {
      "id": "spray-of-cards",
      "title": "Spray Of Cards",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:spray-of-cards"
    },
    {
      "id": "spray-of-cards-ua",
      "title": "Spray of Cards (UA)",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:spray-of-cards-ua"
    },
    {
      "id": "suggestion",
      "title": "Suggestion",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:suggestion"
    },
    {
      "id": "tashas-mind-whip",
      "title": "Tasha's Mind Whip",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:tashas-mind-whip"
    },
    {
      "id": "thought-shield",
      "title": "Thought Shield (UA)",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:thought-shield"
    },
    {
      "id": "vortex-warp",
      "title": "Vortex Warp",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:vortex-warp"
    },
    {
      "id": "warding-wind",
      "title": "Warding Wind",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:warding-wind"
    },
    {
      "id": "warp-sense",
      "title": "Warp Sense",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:warp-sense"
    },
    {
      "id": "web",
      "title": "Web",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:web"
    },
    {
      "id": "wither-and-bloom",
      "title": "Wither and Bloom",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:wither-and-bloom"
    },
    {
      "id": "wristpocket",
      "title": "Wristpocket",
      "level": 2,
      "url": "http://dnd5e.wikidot.com/spell:wristpocket"
    }
  ],
  [
    {
      "id": "animate-dead",
      "title": "Animate Dead",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:animate-dead"
    },
    {
      "id": "antagonize",
      "title": "Antagonize",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:antagonize"
    },
    {
      "id": "antagonize-ua",
      "title": "Antagonize (UA)",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:antagonize-ua"
    },
    {
      "id": "ashardalons-stride",
      "title": "Ashardalon's Stride",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:ashardalons-stride"
    },
    {
      "id": "bestow-curse",
      "title": "Bestow Curse",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:bestow-curse"
    },
    {
      "id": "blink",
      "title": "Blink",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:blink"
    },
    {
      "id": "catnap",
      "title": "Catnap",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:catnap"
    },
    {
      "id": "clairvoyance",
      "title": "Clairvoyance",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:clairvoyance"
    },
    {
      "id": "conjure-lesser-demon",
      "title": "Conjure Lesser Demon (UA)",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:conjure-lesser-demon"
    },
    {
      "id": "counterspell",
      "title": "Counterspell",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:counterspell"
    },
    {
      "id": "dispel-magic",
      "title": "Dispel Magic",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:dispel-magic"
    },
    {
      "id": "enemies-abound",
      "title": "Enemies Abound",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:enemies-abound"
    },
    {
      "id": "erupting-earth",
      "title": "Erupting Earth",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:erupting-earth"
    },
    {
      "id": "fast-friends",
      "title": "Fast Friends",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:fast-friends"
    },
    {
      "id": "fear",
      "title": "Fear",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:fear"
    },
    {
      "id": "feign-death",
      "title": "Feign Death",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:feign-death"
    },
    {
      "id": "fireball",
      "title": "Fireball",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:fireball"
    },
    {
      "id": "flame-arrows",
      "title": "Flame Arrows",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:flame-arrows"
    },
    {
      "id": "flame-stride",
      "title": "Flame Stride (UA)",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:flame-stride"
    },
    {
      "id": "fly",
      "title": "Fly",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:fly"
    },
    {
      "id": "galders-tower",
      "title": "Galder's Tower",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:galders-tower"
    },
    {
      "id": "gaseous-form",
      "title": "Gaseous Form",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:gaseous-form"
    },
    {
      "id": "glyph-of-warding",
      "title": "Glyph of Warding",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:glyph-of-warding"
    },
    {
      "id": "haste",
      "title": "Haste",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:haste"
    },
    {
      "id": "haywire",
      "title": "Haywire (UA)",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:haywire"
    },
    {
      "id": "house-of-cards-ua",
      "title": "House of Cards (UA)",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:house-of-cards-ua"
    },
    {
      "id": "hypnotic-pattern",
      "title": "Hypnotic Pattern",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:hypnotic-pattern"
    },
    {
      "id": "incite-greed",
      "title": "Incite Greed",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:incite-greed"
    },
    {
      "id": "intellect-fortress",
      "title": "Intellect Fortress",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:intellect-fortress"
    },
    {
      "id": "invisibility-to-cameras",
      "title": "Invisibility To Cameras (UA)",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:invisibility-to-cameras"
    },
    {
      "id": "leomunds-tiny-hut",
      "title": "Leomund's Tiny Hut",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:leomunds-tiny-hut"
    },
    {
      "id": "life-transference",
      "title": "Life Transference",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:life-transference"
    },
    {
      "id": "lightning-bolt",
      "title": "Lightning Bolt",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:lightning-bolt"
    },
    {
      "id": "magic-circle",
      "title": "Magic Circle",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:magic-circle"
    },
    {
      "id": "major-image",
      "title": "Major Image",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:major-image"
    },
    {
      "id": "melfs-minute-meteors",
      "title": "Melf's Minute Meteors",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:melfs-minute-meteors"
    },
    {
      "id": "nondetection",
      "title": "Nondetection",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:nondetection"
    },
    {
      "id": "phantom-steed",
      "title": "Phantom Steed",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:phantom-steed"
    },
    {
      "id": "protection-from-ballistics",
      "title": "Protection from Ballistics (UA)",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:protection-from-ballistics"
    },
    {
      "id": "protection-from-energy",
      "title": "Protection from Energy",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:protection-from-energy"
    },
    {
      "id": "psionic-blast",
      "title": "Psionic Blast (UA)",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:psionic-blast"
    },
    {
      "id": "pulse-wave",
      "title": "Pulse Wave",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:pulse-wave"
    },
    {
      "id": "remove-curse",
      "title": "Remove Curse",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:remove-curse"
    },
    {
      "id": "sending",
      "title": "Sending",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:sending"
    },
    {
      "id": "sleet-storm",
      "title": "Sleet Storm",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:sleet-storm"
    },
    {
      "id": "slow",
      "title": "Slow",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:slow"
    },
    {
      "id": "speak-with-dead",
      "title": "Speak with Dead",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:speak-with-dead"
    },
    {
      "id": "spirit-shroud",
      "title": "Spirit Shroud",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:spirit-shroud"
    },
    {
      "id": "stinking-cloud",
      "title": "Stinking Cloud",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:stinking-cloud"
    },
    {
      "id": "summon-fey",
      "title": "Summon Fey",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:summon-fey"
    },
    {
      "id": "summon-lesser-demons",
      "title": "Summon Lesser Demons",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:summon-lesser-demons"
    },
    {
      "id": "summon-shadowspawn",
      "title": "Summon Shadowspawn",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:summon-shadowspawn"
    },
    {
      "id": "summon-undead",
      "title": "Summon Undead",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:summon-undead"
    },
    {
      "id": "summon-warrior-spirit",
      "title": "Summon Warrior Spirit (UA)",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:summon-warrior-spirit"
    },
    {
      "id": "thunder-step",
      "title": "Thunder Step",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:thunder-step"
    },
    {
      "id": "tidal-wave",
      "title": "Tidal Wave",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:tidal-wave"
    },
    {
      "id": "tiny-servant",
      "title": "Tiny Servant",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:tiny-servant"
    },
    {
      "id": "tongues",
      "title": "Tongues",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:tongues"
    },
    {
      "id": "vampiric-touch",
      "title": "Vampiric Touch",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:vampiric-touch"
    },
    {
      "id": "wall-of-sand",
      "title": "Wall of Sand",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:wall-of-sand"
    },
    {
      "id": "wall-of-water",
      "title": "Wall of Water",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:wall-of-water"
    },
    {
      "id": "water-breathing",
      "title": "Water Breathing",
      "level": 3,
      "url": "http://dnd5e.wikidot.com/spell:water-breathing"
    }
  ],
  [
    {
      "id": "arcane-eye",
      "title": "Arcane Eye",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:arcane-eye"
    },
    {
      "id": "banishment",
      "title": "Banishment",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:banishment"
    },
    {
      "id": "blight",
      "title": "Blight",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:blight"
    },
    {
      "id": "charm-monster",
      "title": "Charm Monster",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:charm-monster"
    },
    {
      "id": "confusion",
      "title": "Confusion",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:confusion"
    },
    {
      "id": "conjure-barlgura",
      "title": "Conjure Barlgura (UA)",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:conjure-barlgura"
    },
    {
      "id": "conjure-knowbot",
      "title": "Conjure Knowbot (UA)",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:conjure-knowbot"
    },
    {
      "id": "conjure-minor-elementals",
      "title": "Conjure Minor Elementals",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:conjure-minor-elementals"
    },
    {
      "id": "conjure-shadow-demon",
      "title": "Conjure Shadow Demon (UA)",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:conjure-shadow-demon"
    },
    {
      "id": "control-water",
      "title": "Control Water",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:control-water"
    },
    {
      "id": "dimension-door",
      "title": "Dimension Door",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:dimension-door"
    },
    {
      "id": "divination",
      "title": "Divination",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:divination"
    },
    {
      "id": "ego-whip",
      "title": "Ego Whip (UA)",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:ego-whip"
    },
    {
      "id": "elemental-bane",
      "title": "Elemental Bane",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:elemental-bane"
    },
    {
      "id": "evards-black-tentacles",
      "title": "Evard's Black Tentacles",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:evards-black-tentacles"
    },
    {
      "id": "fabricate",
      "title": "Fabricate",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:fabricate"
    },
    {
      "id": "fire-shield",
      "title": "Fire Shield",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:fire-shield"
    },
    {
      "id": "galders-speedy-courier",
      "title": "Galder's Speedy Courier",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:galders-speedy-courier"
    },
    {
      "id": "gate-seal",
      "title": "Gate Seal",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:gate-seal"
    },
    {
      "id": "gravity-sinkhole",
      "title": "Gravity Sinkhole",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:gravity-sinkhole"
    },
    {
      "id": "greater-invisibility",
      "title": "Greater Invisibility",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:greater-invisibility"
    },
    {
      "id": "hallucinatory-terrain",
      "title": "Hallucinatory Terrain",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:hallucinatory-terrain"
    },
    {
      "id": "ice-storm",
      "title": "Ice Storm",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:ice-storm"
    },
    {
      "id": "leomunds-secret-chest",
      "title": "Leomund's Secret Chest",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:leomunds-secret-chest"
    },
    {
      "id": "locate-creature",
      "title": "Locate Creature",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:locate-creature"
    },
    {
      "id": "mordenkainens-faithful-hound",
      "title": "Mordenkainen's Faithful Hound",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:mordenkainens-faithful-hound"
    },
    {
      "id": "mordenkainens-private-sanctum",
      "title": "Mordenkainen's Private Sanctum",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:mordenkainens-private-sanctum"
    },
    {
      "id": "otilukes-resilient-sphere",
      "title": "Otiluke's Resilient Sphere",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:otilukes-resilient-sphere"
    },
    {
      "id": "phantasmal-killer",
      "title": "Phantasmal Killer",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:phantasmal-killer"
    },
    {
      "id": "polymorph",
      "title": "Polymorph",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:polymorph"
    },
    {
      "id": "raulothims-psychic-lance",
      "title": "Raulothim's Psychic Lance",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:raulothims-psychic-lance"
    },
    {
      "id": "raulothims-psychic-lance-ua",
      "title": "Raulothim's Psychic Lance (UA)",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:raulothims-psychic-lance-ua"
    },
    {
      "id": "sickening-radiance",
      "title": "Sickening Radiance",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:sickening-radiance"
    },
    {
      "id": "spirit-of-death",
      "title": "Spirit Of Death",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:spirit-of-death"
    },
    {
      "id": "spirit-of-death-ua",
      "title": "Spirit of Death (UA)",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:spirit-of-death-ua"
    },
    {
      "id": "stone-shape",
      "title": "Stone Shape",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:stone-shape"
    },
    {
      "id": "stoneskin",
      "title": "Stoneskin",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:stoneskin"
    },
    {
      "id": "storm-sphere",
      "title": "Storm Sphere",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:storm-sphere"
    },
    {
      "id": "summon-aberration",
      "title": "Summon Aberration",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:summon-aberration"
    },
    {
      "id": "summon-construct",
      "title": "Summon Construct",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:summon-construct"
    },
    {
      "id": "summon-elemental",
      "title": "Summon Elemental",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:summon-elemental"
    },
    {
      "id": "summon-greater-demon",
      "title": "Summon Greater Demon",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:summon-greater-demon"
    },
    {
      "id": "synchronicity",
      "title": "Synchronicity (UA)",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:synchronicity"
    },
    {
      "id": "system-backdoor",
      "title": "System Backdoor (UA)",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:system-backdoor"
    },
    {
      "id": "vitriolic-sphere",
      "title": "Vitriolic Sphere",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:vitriolic-sphere"
    },
    {
      "id": "wall-of-fire",
      "title": "Wall of Fire",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:wall-of-fire"
    },
    {
      "id": "watery-sphere",
      "title": "Watery Sphere",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:watery-sphere"
    },
    {
      "id": "widogast-s-vault-of-amber-hb",
      "title": "Widogast's Vault of Amber (HB)",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:widogast-s-vault-of-amber-hb"
    },
    {
      "id": "widogast-s-web-of-fire-hb",
      "title": "Widogast's Web of Fire (HB)",
      "level": 4,
      "url": "http://dnd5e.wikidot.com/spell:widogast-s-web-of-fire-hb"
    }
  ],
  [
    {
      "id": "animate-objects",
      "title": "Animate Objects",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:animate-objects"
    },
    {
      "id": "bigbys-hand",
      "title": "Bigby's Hand",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:bigbys-hand"
    },
    {
      "id": "cloudkill",
      "title": "Cloudkill",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:cloudkill"
    },
    {
      "id": "commune-with-city",
      "title": "Commune with City (UA)",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:commune-with-city"
    },
    {
      "id": "cone-of-cold",
      "title": "Cone of Cold",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:cone-of-cold"
    },
    {
      "id": "conjure-elemental",
      "title": "Conjure Elemental",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:conjure-elemental"
    },
    {
      "id": "conjure-vrock",
      "title": "Conjure Vrock (UA)",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:conjure-vrock"
    },
    {
      "id": "contact-other-plane",
      "title": "Contact Other Plane",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:contact-other-plane"
    },
    {
      "id": "control-winds",
      "title": "Control Winds",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:control-winds"
    },
    {
      "id": "create-spelljamming-helm",
      "title": "Create Spelljamming Helm",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:create-spelljamming-helm"
    },
    {
      "id": "creation",
      "title": "Creation",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:creation"
    },
    {
      "id": "danse-macabre",
      "title": "Danse Macabre",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:danse-macabre"
    },
    {
      "id": "dawn",
      "title": "Dawn",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:dawn"
    },
    {
      "id": "dominate-person",
      "title": "Dominate Person",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:dominate-person"
    },
    {
      "id": "dream",
      "title": "Dream",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:dream"
    },
    {
      "id": "enervation",
      "title": "Enervation",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:enervation"
    },
    {
      "id": "far-step",
      "title": "Far Step",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:far-step"
    },
    {
      "id": "geas",
      "title": "Geas",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:geas"
    },
    {
      "id": "hold-monster",
      "title": "Hold Monster",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:hold-monster"
    },
    {
      "id": "immolation",
      "title": "Immolation",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:immolation"
    },
    {
      "id": "infernal-calling",
      "title": "Infernal Calling",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:infernal-calling"
    },
    {
      "id": "legend-lore",
      "title": "Legend Lore",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:legend-lore"
    },
    {
      "id": "mislead",
      "title": "Mislead",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:mislead"
    },
    {
      "id": "modify-memory",
      "title": "Modify Memory",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:modify-memory"
    },
    {
      "id": "negative-energy-flood",
      "title": "Negative Energy Flood",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:negative-energy-flood"
    },
    {
      "id": "passwall",
      "title": "Passwall",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:passwall"
    },
    {
      "id": "planar-binding",
      "title": "Planar Binding",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:planar-binding"
    },
    {
      "id": "rarys-telepathic-bond",
      "title": "Rary's Telepathic Bond",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:rarys-telepathic-bond"
    },
    {
      "id": "scrying",
      "title": "Scrying",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:scrying"
    },
    {
      "id": "seeming",
      "title": "Seeming",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:seeming"
    },
    {
      "id": "shutdown",
      "title": "Shutdown (UA)",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:shutdown"
    },
    {
      "id": "skill-empowerment",
      "title": "Skill Empowerment",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:skill-empowerment"
    },
    {
      "id": "steel-wind-strike",
      "title": "Steel Wind Strike",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:steel-wind-strike"
    },
    {
      "id": "summon-draconic-spirit",
      "title": "Summon Draconic Spirit",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:summon-draconic-spirit"
    },
    {
      "id": "summon-draconic-spirit-ua",
      "title": "Summon Draconic Spirit (UA)",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:summon-draconic-spirit-ua"
    },
    {
      "id": "synaptic-static",
      "title": "Synaptic Static",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:synaptic-static"
    },
    {
      "id": "telekinesis",
      "title": "Telekinesis",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:telekinesis"
    },
    {
      "id": "teleportation-circle",
      "title": "Teleportation Circle",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:teleportation-circle"
    },
    {
      "id": "temporal-shunt",
      "title": "Temporal Shunt",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:temporal-shunt"
    },
    {
      "id": "transmute-rock",
      "title": "Transmute Rock",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:transmute-rock"
    },
    {
      "id": "wall-of-force",
      "title": "Wall of Force",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:wall-of-force"
    },
    {
      "id": "wall-of-light",
      "title": "Wall of Light",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:wall-of-light"
    },
    {
      "id": "wall-of-stone",
      "title": "Wall of Stone",
      "level": 5,
      "url": "http://dnd5e.wikidot.com/spell:wall-of-stone"
    }
  ],
  [
    {
      "id": "arcane-gate",
      "title": "Arcane Gate",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:arcane-gate"
    },
    {
      "id": "chain-lightning",
      "title": "Chain Lightning",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:chain-lightning"
    },
    {
      "id": "circle-of-death",
      "title": "Circle of Death",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:circle-of-death"
    },
    {
      "id": "contingency",
      "title": "Contingency",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:contingency"
    },
    {
      "id": "create-homunculus",
      "title": "Create Homunculus",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:create-homunculus"
    },
    {
      "id": "create-undead",
      "title": "Create Undead",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:create-undead"
    },
    {
      "id": "disintegrate",
      "title": "Disintegrate",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:disintegrate"
    },
    {
      "id": "drawmijs-instant-summons",
      "title": "Drawmij's Instant Summons",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:drawmijs-instant-summons"
    },
    {
      "id": "eyebite",
      "title": "Eyebite",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:eyebite"
    },
    {
      "id": "fizbans-platinum-shield",
      "title": "Fizban's Platinum Shield",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:fizbans-platinum-shield"
    },
    {
      "id": "fizban-s-platinum-shield-ua",
      "title": "Fizban's Platinum Shield (UA)",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:fizban-s-platinum-shield-ua"
    },
    {
      "id": "flesh-to-stone",
      "title": "Flesh to Stone",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:flesh-to-stone"
    },
    {
      "id": "globe-of-invulnerability",
      "title": "Globe of Invulnerability",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:globe-of-invulnerability"
    },
    {
      "id": "gravity-fissure",
      "title": "Gravity Fissure",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:gravity-fissure"
    },
    {
      "id": "guards-and-wards",
      "title": "Guards and Wards",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:guards-and-wards"
    },
    {
      "id": "investiture-of-flame",
      "title": "Investiture of Flame",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:investiture-of-flame"
    },
    {
      "id": "investiture-of-ice",
      "title": "Investiture of Ice",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:investiture-of-ice"
    },
    {
      "id": "investiture-of-stone",
      "title": "Investiture of Stone",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:investiture-of-stone"
    },
    {
      "id": "investiture-of-wind",
      "title": "Investiture of Wind",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:investiture-of-wind"
    },
    {
      "id": "magic-jar",
      "title": "Magic Jar",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:magic-jar"
    },
    {
      "id": "mass-suggestion",
      "title": "Mass Suggestion",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:mass-suggestion"
    },
    {
      "id": "mental-prison",
      "title": "Mental Prison",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:mental-prison"
    },
    {
      "id": "move-earth",
      "title": "Move Earth",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:move-earth"
    },
    {
      "id": "otherworldly-form",
      "title": "Otherworldly Form (UA)",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:otherworldly-form"
    },
    {
      "id": "otilukes-freezing-sphere",
      "title": "Otiluke's Freezing Sphere",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:otilukes-freezing-sphere"
    },
    {
      "id": "ottos-irresistible-dance",
      "title": "Otto's Irresistible Dance",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:ottos-irresistible-dance"
    },
    {
      "id": "programmed-illusion",
      "title": "Programmed Illusion",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:programmed-illusion"
    },
    {
      "id": "psychic-crush",
      "title": "Psychic Crush (UA)",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:psychic-crush"
    },
    {
      "id": "scatter",
      "title": "Scatter",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:scatter"
    },
    {
      "id": "soul-cage",
      "title": "Soul Cage",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:soul-cage"
    },
    {
      "id": "summon-fiend",
      "title": "Summon Fiend",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:summon-fiend"
    },
    {
      "id": "sunbeam",
      "title": "Sunbeam",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:sunbeam"
    },
    {
      "id": "tashas-otherworldly-guise",
      "title": "Tasha's Otherworldly Guise",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:tashas-otherworldly-guise"
    },
    {
      "id": "tensers-transformation",
      "title": "Tenser's Transformation",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:tensers-transformation"
    },
    {
      "id": "true-seeing",
      "title": "True Seeing",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:true-seeing"
    },
    {
      "id": "wall-of-ice",
      "title": "Wall of Ice",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:wall-of-ice"
    },
    {
      "id": "widogast-s-transmogrification-hb",
      "title": "Widogast's Transmogrification (HB)",
      "level": 6,
      "url": "http://dnd5e.wikidot.com/spell:widogast-s-transmogrification-hb"
    }
  ],
  [
    {
      "id": "conjure-hezrou",
      "title": "Conjure Hezrou (UA)",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:conjure-hezrou"
    },
    {
      "id": "create-magen",
      "title": "Create Magen",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:create-magen"
    },
    {
      "id": "crown-of-stars",
      "title": "Crown of Stars",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:crown-of-stars"
    },
    {
      "id": "delayed-blast-fireball",
      "title": "Delayed Blast Fireball",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:delayed-blast-fireball"
    },
    {
      "id": "draconic-transformation",
      "title": "Draconic Transformation",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:draconic-transformation"
    },
    {
      "id": "draconic-transformation-ua",
      "title": "Draconic Transformation (UA)",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:draconic-transformation-ua"
    },
    {
      "id": "dream-of-the-blue-veil",
      "title": "Dream of the Blue Veil",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:dream-of-the-blue-veil"
    },
    {
      "id": "etherealness",
      "title": "Etherealness",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:etherealness"
    },
    {
      "id": "finger-of-death",
      "title": "Finger of Death",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:finger-of-death"
    },
    {
      "id": "forcecage",
      "title": "Forcecage",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:forcecage"
    },
    {
      "id": "mirage-arcane",
      "title": "Mirage Arcane",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:mirage-arcane"
    },
    {
      "id": "mordenkainens-magnificent-mansion",
      "title": "Mordenkainen's Magnificent Mansion",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:mordenkainens-magnificent-mansion"
    },
    {
      "id": "mordenkainens-sword",
      "title": "Mordenkainen's Sword",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:mordenkainens-sword"
    },
    {
      "id": "plane-shift",
      "title": "Plane Shift",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:plane-shift"
    },
    {
      "id": "power-word-pain",
      "title": "Power Word: Pain",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:power-word-pain"
    },
    {
      "id": "prismatic-spray",
      "title": "Prismatic Spray",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:prismatic-spray"
    },
    {
      "id": "project-image",
      "title": "Project Image",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:project-image"
    },
    {
      "id": "reverse-gravity",
      "title": "Reverse Gravity",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:reverse-gravity"
    },
    {
      "id": "sequester",
      "title": "Sequester",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:sequester"
    },
    {
      "id": "simulacrum",
      "title": "Simulacrum",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:simulacrum"
    },
    {
      "id": "symbol",
      "title": "Symbol",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:symbol"
    },
    {
      "id": "teleport",
      "title": "Teleport",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:teleport"
    },
    {
      "id": "tether-essence",
      "title": "Tether Essence",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:tether-essence"
    },
    {
      "id": "whirlwind",
      "title": "Whirlwind",
      "level": 7,
      "url": "http://dnd5e.wikidot.com/spell:whirlwind"
    }
  ],
  [
    {
      "id": "abi-dalzims-horrid-wilting",
      "title": "Abi-Dalzim's Horrid Wilting",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:abi-dalzims-horrid-wilting"
    },
    {
      "id": "antimagic-field",
      "title": "Antimagic Field",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:antimagic-field"
    },
    {
      "id": "antipathy-sympathy",
      "title": "Antipathy/Sympathy",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:antipathy-sympathy"
    },
    {
      "id": "clone",
      "title": "Clone",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:clone"
    },
    {
      "id": "control-weather",
      "title": "Control Weather",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:control-weather"
    },
    {
      "id": "dark-star",
      "title": "Dark Star",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:dark-star"
    },
    {
      "id": "demiplane",
      "title": "Demiplane",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:demiplane"
    },
    {
      "id": "dominate-monster",
      "title": "Dominate Monster",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:dominate-monster"
    },
    {
      "id": "feeblemind",
      "title": "Feeblemind",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:feeblemind"
    },
    {
      "id": "illusory-dragon",
      "title": "Illusory Dragon",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:illusory-dragon"
    },
    {
      "id": "incendiary-cloud",
      "title": "Incendiary Cloud",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:incendiary-cloud"
    },
    {
      "id": "maddening-darkness",
      "title": "Maddening Darkness",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:maddening-darkness"
    },
    {
      "id": "maze",
      "title": "Maze",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:maze"
    },
    {
      "id": "mighty-fortress",
      "title": "Mighty Fortress",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:mighty-fortress"
    },
    {
      "id": "mind-blank",
      "title": "Mind Blank",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:mind-blank"
    },
    {
      "id": "power-word-stun",
      "title": "Power Word: Stun",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:power-word-stun"
    },
    {
      "id": "reality-break",
      "title": "Reality Break",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:reality-break"
    },
    {
      "id": "sunburst",
      "title": "Sunburst",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:sunburst"
    },
    {
      "id": "telepathy",
      "title": "Telepathy",
      "level": 8,
      "url": "http://dnd5e.wikidot.com/spell:telepathy"
    }
  ],
  [
    {
      "id": "astral-projection",
      "title": "Astral Projection",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:astral-projection"
    },
    {
      "id": "blade-of-disaster",
      "title": "Blade of Disaster",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:blade-of-disaster"
    },
    {
      "id": "foresight",
      "title": "Foresight",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:foresight"
    },
    {
      "id": "gate",
      "title": "Gate",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:gate"
    },
    {
      "id": "imprisonment",
      "title": "Imprisonment",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:imprisonment"
    },
    {
      "id": "invulnerability",
      "title": "Invulnerability",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:invulnerability"
    },
    {
      "id": "mass-polymorph",
      "title": "Mass Polymorph",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:mass-polymorph"
    },
    {
      "id": "meteor-swarm",
      "title": "Meteor Swarm",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:meteor-swarm"
    },
    {
      "id": "power-word-kill",
      "title": "Power Word: Kill",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:power-word-kill"
    },
    {
      "id": "prismatic-wall",
      "title": "Prismatic Wall",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:prismatic-wall"
    },
    {
      "id": "psychic-scream",
      "title": "Psychic Scream",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:psychic-scream"
    },
    {
      "id": "ravenous-void",
      "title": "Ravenous Void",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:ravenous-void"
    },
    {
      "id": "shapechange",
      "title": "Shapechange",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:shapechange"
    },
    {
      "id": "time-ravage",
      "title": "Time Ravage",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:time-ravage"
    },
    {
      "id": "time-stop",
      "title": "Time Stop",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:time-stop"
    },
    {
      "id": "true-polymorph",
      "title": "True Polymorph",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:true-polymorph"
    },
    {
      "id": "weird",
      "title": "Weird",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:weird"
    },
    {
      "id": "wish",
      "title": "Wish",
      "level": 9,
      "url": "http://dnd5e.wikidot.com/spell:wish"
    }
  ]
]
